module.exports = __webpack_public_path__ + "img/FLSH3.05f6fff1.svg";